import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';
import type { ICreateTicketRequest } from './create-ticket-request';

export async function createTicketApi(
  body: ICreateTicketRequest,
): Promise<IValidatedResponse<ITicketResponse>> {
  return postRequest<ITicketResponse>({
    path: '/ticket',
    body,
    schema: ticketResponseSchema,
  });
}
